import { defineMessages } from 'react-intl';

export default defineMessages({
  back: {
    id: 'src.pages.CreateClaim.back',
    defaultMessage: 'Back',
  },
  startYourClaim: {
    id: 'src.pages.CreateClaim.startYourClaim',
    defaultMessage: 'Start your claim',
  },
  sixStepsToCompleteClaim: {
    id: 'src.pages.CreateClaim.sixSteps',
    defaultMessage: '6 easy steps to complete your claim',
  },
  infoSecured: {
    id: 'src.pages.CreateClaim.infoSecured',
    defaultMessage: ' ',
  },
});
